import React from "react";
import PropTypes from "prop-types";
import styles from "./ContentContainer.module.css";

const ContentContainer = ({ maxWidth = "75em", children }) => {
  const containerStyle = {
    maxWidth: maxWidth,
    margin: "0 auto",
  };

  return (
    <div
      className={styles.ContentContainer}
      style={containerStyle}
      data-testid="ContentContainer"
    >
      {children}
    </div>
  );
};

ContentContainer.propTypes = {
  maxWidth: PropTypes.string,
};

export default ContentContainer;